import { createRef, PureComponent } from "react";
import classnames from "classnames";
import Colors from "styles/colors";
import Arrow from "static/svg/docs/arrow-up.svg";
import AssetComponent from "components/core/asset/asset-component";
import BadgeComponent from "components/core/badge/badge-component";
import MondayMarkupLanguageComponent from "client/components/system/monday-markup-language/monday-markup-language-component";
import { scrollIntoViewWithOffset } from "utils/dom";
import constants from "segments/desktop/header/layouts/components/basic-header/constants";
import { trackEvent } from "services/bigbrain-service";
import { TAB_CLICKED } from "constants/bigbrain-event-types";
import { componentStyles } from "./vertical-timer-tab-mobile-component.scss";
import ProgressBarComponent from "../../progressbar/progressbar-component";

export default class VerticalTimerTabMobileComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.tabRef = createRef();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { isSelected } = this.props;

    if (isSelected && isSelected !== prevProps.isSelected) {
      scrollIntoViewWithOffset(this.tabRef, constants.BASIC_HEADER_HEIGHT);
    }
  }

  handleTitleClick = () => {
    const { setSelectedTab, index, title, getTabIdentifier, isSelected } = this.props;
    const identifier = getTabIdentifier ? getTabIdentifier(this.props) : title;

    trackEvent(TAB_CLICKED, {
      kind: identifier,
      info1: index,
      info2: isSelected
    });
    setSelectedTab(index);
  };

  renderRightSide() {
    const { assetQuality, asset, rightSideRenderer, backgroundColor } = this.props;

    const shouldDisplayImage = (asset && asset?.image?.src) || asset?.video?.src;

    if (!shouldDisplayImage && rightSideRenderer) return rightSideRenderer(this.props);

    return (
      <div className="vertical-timer-tab-mobile-asset" style={{ backgroundColor: Colors[backgroundColor] }}>
        <AssetComponent {...asset} assetQuality={assetQuality} convertGifToVideo={true} />
      </div>
    );
  }

  render() {
    const {
      title,
      tabContentRenderer,
      content,
      badgeText,
      fontColor,
      selectedFontColor,
      titleFontWeight,
      fontSize,
      selectedFontSize,
      tabTitleRenderer,
      ...rest
    } = this.props;
    const { isSelected, alwaysShowProgressbar, showArrow, progressbarColor, arrowSize, lineHeight } = this.props;

    const color = isSelected ? Colors[selectedFontColor] : Colors[fontColor];

    return (
      <div className="vertical-timer-tab-mobile-component">
        <div
          ref={this.tabRef}
          className={classnames("vertical-timer-tab-mobile-title", {
            "vertical-timer-tab-mobile-title-selected": isSelected
          })}
          onClick={this.handleTitleClick}
          style={{ fontSize: isSelected ? selectedFontSize : fontSize }}
        >
          {tabTitleRenderer ? (
            tabTitleRenderer(title, { ...rest })
          ) : (
            <MondayMarkupLanguageComponent
              tagName="span"
              style={{ color, fontWeight: titleFontWeight, lineHeight }}
              text={title}
            />
          )}

          {badgeText && (
            <div className="vertical-timer-tab-mobile-title-badge-margin">
              <BadgeComponent badgeText={badgeText} />
            </div>
          )}

          <span className="vertical-timer-tab-arrow-wrapper">
            {showArrow && (
              <Arrow
                className={classnames("vertical-timer-tab-arrow", { selected: isSelected })}
                style={{ color, width: arrowSize }}
              />
            )}
          </span>
        </div>

        <div className="vertical-timer-tab-mobile-progress-container">
          {alwaysShowProgressbar && (
            <ProgressBarComponent forceProgressbarDone progressbarColor={progressbarColor} enabled={isSelected} />
          )}
        </div>

        <div
          className={classnames("vertical-timer-tab-mobile-content-container", {
            "vertical-timer-tab-mobile-content-container-selected": isSelected
          })}
        >
          {isSelected ? (
            <>
              <div className="vertical-timer-tab-mobile-content">
                {tabContentRenderer ? (
                  tabContentRenderer(content, { ...rest })
                ) : (
                  <MondayMarkupLanguageComponent text={content} />
                )}
              </div>
              {this.renderRightSide()}
            </>
          ) : (
            <></>
          )}
        </div>

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}
